module.exports = __webpack_public_path__ + "img/result_qr.a439bc55.jpeg";